<template>
  <div>
    <div class="box">
      <BInputPullDown
        label-name="班级名称"
        v-model="classId"
        :Options="classNameList"
      />
      <BInputPullDown
        label-name="课程名称"
        v-model="courseId"
        :Options="courseNameList"
      />
      <div class="mar-lef">有效期： {{courseValidTime}}</div>
      <div class="mar-lef">培训课时： {{courseHours}}</div>
    </div>
    <div class="box">
      <BInputText
        label-text="关键字"
        v-model="lessonName"
        placeholder="名称"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <Table
        :headers="headers"
        class="timeDiscount"
        :tableData="lessonList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div style="display:flex;flex-direction:row;justify-content: center;">
            <div class="btn-detail">
              <!-- <a :href="item.data.fileUrl" target="_blank" :download="item.data.fileUrl" style="text-decoration: none;color: #0171a3;">下载</a> -->
              <span
                @click="download(item)"
              >
                下载
              </span>
            </div>
            <!-- <div class="btn-detail" @click="handleDetail(item.data)">
              <span>
                查看
              </span> -->
              <!-- <a :href="item.data.fileUrl" target="_blank" style="text-decoration: none;color: #0171a3;">查看</a> -->
            <!-- </div> -->
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
// import {searchList,searchInit,courseDetail, trainCourseFileBrowseUpdate } from "@/api/stuFileManagement";
import {searchList,searchInit,searchCoursesList,courseDetail } from "@/api/stuFileManagement";
import BInputPullDown from "../../components2/BInputPullDown";
import BInputText from "../../components2/BInputText";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Table from "../../components2/Table";
export default {
  name: "CourseManagement",
  components: {
    Table,
    BInputText,
    BInputPullDown,
    BBtnSecondary,
  },
  data() {
    return {
      totalPages: 0,
      page: 1,
      limit: 10,
      totalCount: 0,
      loading: false,
      classNameList: [],
      classId: "",
      courseNameList: [],
      courseId: "",
      id: null,
      cId: null,
      completeFlg: "",
      courseHours: null,
      courseValidTime: "",
      fileName: "",
      fileUrl: "",
      fileId: "",
      lessonName: "",
      headers: [
        { text: "ID", value: "indexNum", sortable: false, align: "center", width: '4%' },
        { text: "资料名称", value: "fileName", sortable: false, align: "center", },
        { text: "操作", value: "actions", sortable: false, align: "center" },
      ],
      navi: [
        {name: "stu-file-management"},
      ],
      lessonList: [],
      courseIdFlg: false,
    };
  },
  watch:{
      'classId'() {
          this.classChange()
      }
  },
  created() {
   
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$route.params.courseId != undefined) {
        vm.id = vm.$route.params.courseId
      }
      if (vm.$route.params.classId != undefined) {
        vm.cId = vm.$route.params.classId
      }
      vm.searchInit();
    });
  },
  beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
  },
  methods: {

    // 查看
    // async handleDetail(item) {
    //   const data = await trainCourseFileBrowseUpdate(item.fileId);
    //   console.log(data)

    //   window.location.href =
    //       process.env.VUE_APP_BASE_API+'/api/stuTrainFile/download?fileUrl='+item.fileUrl+'&fileName='+item.fileName+'&flg='+true
    // },
   
    /**
     * 资料管理下拉列表初始化
     */
    async searchInit() {
      const data = await searchInit(this.classId);
      this.classNameList = data.data.classDropDownList;
      this.courseNameList = data.data.courseDropDownList;
      
      if (this.cId == "" || this.cId == null) {
        if( this.classNameList.length > 0 ){
          this.classId = this.classNameList[0].value;
        }
      } else {
        this.classId = String(this.cId);
      }

      if (this.id == "" || this.id == null) {
        this.searchCoursesList()
      } else {
        this.courseId = String(this.id)
        // this.courseDetail(this.courseId);
        this.searchCoursesList()
      }

      // this.courseDetail(this.courseId);
    },

    async classChange () {
      const data = await searchCoursesList(this.classId);
      this.courseNameList = data.data.courseDropDownList;
      this.courseId = this.courseNameList[0].value;
    },
    async searchCoursesList() {
      const data = await searchCoursesList(this.classId);
      this.courseNameList = data.data.courseDropDownList;
      this.courseId = this.courseNameList[0].value;
      this.courseDetail(this.classId, this.courseId);
    },
    async courseDetail(classId, courseId) {
      const data = await courseDetail(classId, courseId);
      if (data.data != null) {
        this.completeFlg = data.data.completeFlg
        this.courseHours = data.data.courseHours
        this.courseValidTime = data.data.courseValidTime
        this.doSearch(true);
      }
    },
    // 查询
    doSearch(flg) {
      this.loading = true;
      if (flg) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 10;
        this.totalCount = 0;
   
      } else {
        // 查询条件赋值
        
      }
      this.searchList();
    },
    async searchList() {
      // 把查询条件存入缓存

      var param = {
        page: this.page,
        limit: this.limit,
        classId: this.classId,
        courseId: this.courseId,
        lessonName: this.comUtils.trim(this.lessonName),
      };
      const data = await searchList(param);

      if (data.data.size != 0) {
        this.lessonList = data.data;
      }
      this.totalCount = data.data.length;
      this.totalPages = Math.ceil(this.totalCount / this.limit);
      if (this.page > this.totalPages && this.totalPages > 0) {
        this.doSearch(true);
      }
      this.loading = false;
    },
    // 下载
    download(item) {
      console.log(item.data.fileName)
      window.location.href =
          process.env.VUE_APP_BASE_API+'/api/stuTrainFile/download?fileUrl='+item.data.fileUrl+'&fileName='+item.data.fileName+'&fileId='+item.data.fileId
          // process.env.VUE_APP_BASE_API+'/api/stuTrainFile/download?fileUrl='+item.data.fileUrl+'&fileName='+item.data.fileName+'&flg='+false
    }
  },
};
</script>

<style scoped>
.main2 {
  position: relative;
  /*margin: 5px 30px 5px 30px;*/
  padding-top: 28px;
  display: flex;
  flex-wrap: wrap;
}

.search-result {
  display: block;
  position: relative;
  margin: 10px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}

.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.timeDiscount{
  white-space: pre-line;
}

.mar-lef {
  margin-left: 180px;
  color: #333333;
}
</style>
